import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  baseUniDriverFactory,
  findByHook,
  ReactBase,
} from '../../utils/test-utils/unidriver';
import { dataHooks } from './constants';

export interface ButtonCoreDriver extends BaseUniDriver {
  getButtonTextContent(): Promise<string>;
  isButtonDisabled(): Promise<boolean>;
  isDisabled(): Promise<boolean>;
  isFocused(): Promise<boolean>;
  isPrefixIconExists(): Promise<boolean>;
  isSuffixIconExists(): Promise<boolean>;
  focus(): Promise<void>;
  getHref(): Promise<string | null>;
  getTabIndex(): Promise<string | null>;
  getTagName(): Promise<string | null>;
  getType(): Promise<string | null>;
  hasPrefixClass(className: string): Promise<boolean>;
  hasSuffixClass(className: string): Promise<boolean>;
}

export const buttonCoreDriverFactory = (base: UniDriver): ButtonCoreDriver => {
  const reactBase = ReactBase(base);
  const getSuffix = () => findByHook(base, dataHooks.suffixIcon);
  const getPrefix = () => findByHook(base, dataHooks.prefixIcon);

  return {
    ...baseUniDriverFactory(base),
    getButtonTextContent: async () => base.text(),
    isButtonDisabled: async () => (await base.attr('aria-disabled')) === 'true',
    isDisabled: async () => (await base.attr('aria-disabled')) === 'true',
    isFocused: async () => reactBase.isFocus(),
    isSuffixIconExists: async () => getSuffix().exists(),
    isPrefixIconExists: async () => getPrefix().exists(),
    focus: () => reactBase.focus(),
    getHref: async () => base.attr('href'),
    getTabIndex: async () => base.attr('tabIndex'),
    getTagName: async () => (await base.prop('tagName')).toLowerCase(),
    getType: async () => (await base.prop('type')).toLowerCase(),
    hasPrefixClass: async className => getPrefix().hasClass(className),
    hasSuffixClass: async className => getSuffix().hasClass(className),
  };
};
